import { useData } from "./DataContext.js";

import DocumentDraggable from "./DocumentDraggable.js";
import StrictModeDroppable from "./StrictModeDroppable.js";


export default function InvestmentDroppable (props)
{
    const gData = useData();
    
    const investmentDocumentIds = gData.state.reports[props.solutionId].investment.documentIds;
    const documentDroppables = investmentDocumentIds.map((documentId, index) => (<DocumentDraggable key={documentId} index={index} documentId={documentId} variableId={null} value="investment"/>));
    const droppableId = props.solutionId + "/investment/investment";
    const disabled = gData.content.params.easyInvestment && props.draggedDocumentId !== null && gData.content.documents[props.draggedDocumentId].variableId !== null;

    //const width = gData.content.params.documentWidth + 4*2 || "auto";
    const width = (gData.content.params.documentWidth + 4*2) * 2 + 12 || "auto";
    const height = gData.content.params.documentHeight * 2 + 4*3 || "auto";

    return (
	<StrictModeDroppable droppableId={droppableId} isDropDisabled={disabled}>
	    {(provided, snapshot) => {
		const isDraggingOver = snapshot.isDraggingOver; // && ! (gData.content.params.easyInvestment && gData.content.documents[snapshot.draggingOverWith].variableId !== null);
		const borderColor = "dark";
		const bgColor = isDraggingOver ? "bg-dark-subtle " : "bg-white ";

		return (
		    <div className={"border border-0 rounded overflow-hidden m-0 p-1 gap-0 d-flex flex-row flex-wrap justify-content-center " + bgColor + borderColor} style={{ width, height, outline: "2px solid var(--bs-"+borderColor+")" }}
			 ref={provided.innerRef}
			     { ...provided.droppableProps }
		    >
			{documentDroppables}
			{provided.placeholder}
		    </div>
		);
	    }}
	</StrictModeDroppable>
    );
}
